module.exports = __webpack_public_path__ + "static/media/dashboard.b19fb7de.svg";